import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent implements OnInit {

  filterForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<FilterModalComponent>,
    private fb: FormBuilder,
  ) {
    this.filterForm = this.fb.group({
      city: this.fb.control('',Validators.compose([Validators.required])),
      bathroom: this.fb.control('',Validators.compose([Validators.required])),
      neighborhood: this.fb.control('',Validators.compose([Validators.required])),
      antiquity: this.fb.control('',Validators.compose([Validators.required])),
      transactionType: this.fb.control('',Validators.compose([Validators.required])),
      area: this.fb.control('',Validators.compose([Validators.required])),
      estateType: this.fb.control('',Validators.compose([Validators.required])),
      status: this.fb.control('',Validators.compose([Validators.required])),
      bedrooms: this.fb.control('',Validators.compose([Validators.required])),
      estateProyects: this.fb.control('',Validators.compose([Validators.required])),

      minDate: this.fb.control('',Validators.compose([Validators.required])),
      maxDate: this.fb.control('',Validators.compose([Validators.required])),

      code: this.fb.control('',Validators.compose([Validators.required, Validators.pattern('[0-9]*')])),
    });
   }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
